import { Box, Typography } from "@mui/material";
import { MONO, eyebrow, tokens } from "./../theme";

// Mono uppercase section label — the console's structural voice.
export function Eyebrow({ children, sx }) {
  return <Typography component="div" sx={{ ...eyebrow, ...sx }}>{children}</Typography>;
}

// Page header: mono eyebrow + title + optional subtitle, actions on the right.
export function PageHeader({ eyebrow: eb, title, subtitle, actions }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: 2,
        mb: 3,
        flexWrap: "wrap",
      }}
    >
      <Box>
        {eb && <Eyebrow sx={{ mb: 0.75 }}>{eb}</Eyebrow>}
        <Typography variant="h5">{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 620 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>{actions}</Box>}
    </Box>
  );
}

// A single mono readout: big value + unit, with a label above. The workhorse of
// the instrument aesthetic.
export function Metric({ label, value, unit, accent, size = "md" }) {
  const fs = size === "lg" ? "1.6rem" : size === "sm" ? "1.02rem" : "1.32rem";
  return (
    <Box sx={{ minWidth: 0 }}>
      <Eyebrow sx={{ mb: 0.5 }}>{label}</Eyebrow>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
        <Typography
          sx={{ fontFamily: MONO, fontWeight: 600, fontSize: fs, lineHeight: 1, color: accent || "text.primary" }}
        >
          {value}
        </Typography>
        {unit && (
          <Typography sx={{ fontFamily: MONO, fontSize: ".75rem", color: "text.secondary" }}>{unit}</Typography>
        )}
      </Box>
    </Box>
  );
}

// Live status dot with an optional radiating pulse (for "online" telemetry).
export function StatusDot({ color = tokens.ok, pulse = false, size = 8 }) {
  return (
    <Box
      component="span"
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        display: "inline-block",
        flex: "0 0 auto",
        boxShadow: `0 0 0 3px ${color}22`,
        ...(pulse && {
          "@keyframes gpPulse": {
            "0%": { boxShadow: `0 0 0 0 ${color}66` },
            "70%": { boxShadow: `0 0 0 6px ${color}00` },
            "100%": { boxShadow: `0 0 0 0 ${color}00` },
          },
          animation: "gpPulse 2.2s infinite",
        }),
      }}
    />
  );
}
